/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { StateResource } from '@common/tech-shared';
import { UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { Component, inject, Input, OnInit } from '@angular/core';
import { hasLink, Resource } from '@ngxp/rest';
import { Observable } from 'rxjs';

@Component({
  selector: 'alfa-link-with-user-name-tooltip-container',
  templateUrl: './link-with-user-name-tooltip-container.component.html',
  styleUrls: ['./link-with-user-name-tooltip-container.component.scss'],
  standalone: false,
})
export class LinkWithUserNameTooltipContainerComponent implements OnInit {
  private readonly userProfileService = inject(UserProfileService);

  @Input() routerLinkString: string;
  @Input() tooltipTemplate: string;
  @Input() resource: Resource;
  @Input() linkRel: string;

  userProfileStateResource$: Observable<StateResource<UserProfileResource>>;

  ngOnInit(): void {
    if (hasLink(this.resource, this.linkRel)) {
      this.userProfileStateResource$ = this.userProfileService.getAssignedUserProfile(this.resource, this.linkRel);
    }
  }
}
